import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import {storageService} from '../components/StorageService'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/setup/:setupId',
      name: 'Setup',
      component: () => import('../views/Setup')
    },
    {
      path: '/todos/:bikeId',
      name: 'Todos',
      component: () => import('../views/Todo')
    },
    {
      path: '/inprint',
      name: 'Inprint',
      component: () => import('../views/Inprint')
    },
    {
      path: '/springcalculator',
      name: 'Spring Calculator',
      component: () => import('../views/SpringCalculator')
    },
    {
      path: '/spokecalculator',
      name: 'Spoke Calculator',
      component: () => import('../views/SpokeCalculator')
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('../views/Login')
    },
    {
      path: '/admin/hubs',
      name: 'Hubs Admin',
      component: () => import('../views/HubAdmin'),
      meta: {
        private: true,
        onlyWhenLoggedOut: true
      }
    },
    {
      path: '/admin/rims',
      name: 'Rims Admin',
      component: () => import('../views/RimsAdmin'),
      meta: {
        private: true,
        onlyWhenLoggedOut: true
      }
    },
    {
      path: '/:uuid?',
      name: 'Home',
      component: Home
    },
  ]
});

router.beforeEach((to, from, next) => {
  const isPrivate = to.matched.some(record => record.meta.private)
  console.log(storageService.state.apiKey);
  if (isPrivate && (storageService.state.apiKey == null || storageService.state.apiKey == '')) {
    return next({
      path: '/login',
      query: {redirect: to.fullPath}
    });
  }

  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js